import { useMemo } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import {
  useGetProtectedApiDataQuery,
  useGetProtectedApiHtmlQuery,
} from "../../redux/services/apiSlice";
import { getLastUpdatedOn } from "../../Utils/apiFunctions";

const CorporateGovernance = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);

  const {
    data: corporateGovernancePageHtml = {},
    isLoading: corporateGovernancePageIsLoading,
  } = useGetProtectedApiHtmlQuery({ url: 89, lang: languageType });
  const { data: lastUpdatedOnData = [], isLoading: lastUpdatedIsLoading } =
    useGetProtectedApiDataQuery({
      url: "basic_page",
      lang: languageType,
    });

  const lastUpdatedOn = useMemo(
    () => getLastUpdatedOn(lastUpdatedOnData, 89),
    [lastUpdatedOnData],
  );

  const pageBody =
    corporateGovernancePageHtml?.body?.[0]?.value ?? "No content available";

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  if (corporateGovernancePageIsLoading || lastUpdatedIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={getText("About Us", "हमारे संबंध में")}
        titleLink="/about-us/corporate-governance"
        levelTwo={true}
        titleTwo={innerBannerTitle}
        levelThree={false}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <div className="row" role="main" aria-label="Main Content">
              <div dangerouslySetInnerHTML={{ __html: pageBody }} />
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CorporateGovernance;
